import {
    CLEAR_REQUEST,
    SET_ERROR_REQUEST,
    SET_ERROR_REQUEST_RESP,
    SET_SUCCESS_REQUEST,
    SET_SUCCESS_REQUEST_WITH_ID,
    REMOVE_REQUEST_ID,
} from "redux/constants/Request";

const initalAgreementState = {
    loading: true,
    error: false,
    message: "",
};
const Request = (state = initalAgreementState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_SUCCESS_REQUEST:
            return { ...state, loading: false, message: payload };
        case SET_SUCCESS_REQUEST_WITH_ID:
            return {
                ...state,
                loading: false,
                message: payload.msg,
                idd: payload.id,
            };
        case SET_ERROR_REQUEST:
            return { ...state, loading: false, error: true, message: payload };
        case SET_ERROR_REQUEST_RESP:
            return {
                ...state,
                loading: false,
                error: true,
                message: payload.msg,
                resp: payload.status,
            };
        case REMOVE_REQUEST_ID:
            delete state.id;
            return state;
        case CLEAR_REQUEST:
            return initalAgreementState;
        default:
            return state;
    }
};

export default Request;
